<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'ListingNotFound',

    metaInfo: { title: 'Listing not found!' },

    extends: View,

    mixins: [
      LoadSections([
        'ListingNotFound',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
